// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uwMoo","left":"styles_left__2kBGd"};